import axios from "axios";

import type { ServiceResponse } from "@/api/api.types";

export const forgotPassword = async (email: string): Promise<void> => {
  await axios.post<ServiceResponse<void>>("/api/users/send-reset-password", {
    email,
  });
};
